var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"c-overlay",style:({ zIndex: _vm.overlay.zIndex }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccb668be","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/app/plugins/overlay/Overlay.vue
// module id = 273
// module chunks = 65